jQuery(document).ready(function($) {
  // Smooth scroll for anchor links
  $(document).on('click', 'a[href*="#"]:not(.noscroll)', function (event) {

    var pagePath = window.location.pathname,
        linkPath = $.attr(this, 'href').substring(0, $.attr(this, 'href').indexOf("#"));
        elementID = $.attr(this, 'href').substring($.attr(this, 'href').indexOf("#"));

    // console.log(pagePath, linkPath, linkPath.length);

    if( (pagePath === linkPath || linkPath.length === 0) && elementID.length > 1) {
      event.preventDefault();

      if($(elementID).length) {
        $('html, body').animate({
            scrollTop: $(elementID).offset().top - ($('header.header').outerHeight()  || 0) - ($('.is-dropdown-submenu:visible').outerHeight()  || 0)
        }, 500);
        $(elementID).attr('tabindex', 0).focus();
      }
    }
  });

});

function urlParam(name){
  var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
  if (results==null) {
     return null;
  }
  return decodeURI(results[1]) || 0;
}

function animateValue(id, start, end, duration) {
  var range = end - start;
  var current = start;
  var increment = end > start? 1 : -1;
  var stepTime = Math.abs(Math.floor(duration / range));
  var obj = document.getElementById(id);
  var timer = setInterval(function() {
    current += increment;
    obj.innerHTML = current;
    if (current == end) {
      clearInterval(timer);
    }
  }, stepTime);
}
